import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptionsArgs, ResponseContentType } from '@angular/http';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import { HttpService } from '../../shared/services/http.service';
import { AppConfig } from '../../app.config';
import { AuthService } from './auth.service';
import { UserDetail } from '../../models/userDetail';

export const RUNFILE_ACCESS_GROUPS = ['runfile_view']
export const TRACEFIT_ACCESS_GROUPS = ['trace_fit_view']

@Injectable()
export class UserService {
  constructor(private http: HttpService, private authService: AuthService) { }

  getUserDetails(): Observable<UserDetail> {
    return this.http.get(`${AppConfig.settings.apiUrl}/users/self/`, this.getAuthorizationHeader()).retry(2)
      .map((response: Response) => {
        if (!response || !response.json())
          return;

        let data = response.json();
        // console.log(data)
        return {
          id: data.id,
          groupName: data.billing_group,
          isStaff: data.is_staff,
          email: data.email,
          runfileAccess: data.user_groups.some(group => {return RUNFILE_ACCESS_GROUPS.includes(group)}),
          tracefitAccess: data.user_groups.some(group => {return TRACEFIT_ACCESS_GROUPS.includes(group)})
        }
      });
  }

  getBillingGroupAdmin(groupName: string): Observable<string> {
    return this.http.get(`${AppConfig.settings.apiUrl}/billing_groups/${groupName}/`, this.getAuthorizationHeader()).retry(2)
      .map((response: Response) => {
        if (!response || !response.json())
          return;

        let data = response.json();
        if (!data)
          return null;

        return data.billing_admin_user;
      });
  }

  private getAuthorizationHeader(): RequestOptionsArgs {
      let headers = new Headers();
      headers.append('Authorization', this.authService.getTokenHeaderText());
      return { headers };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/user.service.ts